import { Chip } from '@mui/material';

import type { TransferStatus } from '../../api/business/types';
import { useT } from '../../i18n/LanguageContext';

/** Where a transfer is, coloured from the theme: done green, failed red, waiting for the owner blue. */
export const TransferStatusChip = ({ status }: { status: TransferStatus }) => {
  const t = useT();
  const color =
    status === 'DONE' ? 'success' : status === 'FAILED' ? 'error' : status === 'READY' ? 'info' : 'default';

  return (
    <Chip size="small" variant="outlined" color={color} label={t(`transferStatus.${status}` as const)} />
  );
};
